import { GALLERY_LIST, GALLERY_ADDEDIT, GALLERY_GETONE, UPLOAD_PHOTOS, GALLERY_DELETE } from "../../api/constApi";
import { authHeader, fileAuthHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const UploadPhotosApi = (payload) => {
    return apiInstance.post(UPLOAD_PHOTOS, payload, {
        headers: fileAuthHeader(),
    });
};

export const GalleryListApi = (payload) => {
    return apiInstance.post(GALLERY_LIST, payload, {
        headers: authHeader(),
    });
};

export const AddEditGalleryApi = (payload) => {
    return apiInstance.post(GALLERY_ADDEDIT, payload, {
        headers: fileAuthHeader(),
    });
}; 

export const GetOneGalleryApi = (payload) => {
    return apiInstance.post(GALLERY_GETONE, payload, {
        headers: fileAuthHeader(),
    });
};
export const DeleteGalleryApi = (payload) => {
    return apiInstance.post(GALLERY_DELETE, payload,{
        headers: authHeader(),
    });
};